var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.formState,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "日期范围",
      "prop": "time"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "valueFormat": "YYYY-MM-DD"
    },
    model: {
      value: _vm.formState.time,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "time", $$v);
      },
      expression: "formState.time"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "维修状态",
      "prop": "repairsStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择维修状态"
    },
    model: {
      value: _vm.formState.repairsStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.formState, "repairsStatus", $$v);
      },
      expression: "formState.repairsStatus"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("草稿")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("待受理")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待派单")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("待接单")]), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("不受理")]), _c('a-select-option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("维修中")]), _c('a-select-option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("已完成")]), _c('a-select-option', {
    attrs: {
      "value": 7
    }
  }, [_vm._v("待评价")]), _c('a-select-option', {
    attrs: {
      "value": 8
    }
  }, [_vm._v("外部维修")])], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchClick
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v(" 重置 ")])], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.list,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.change
    },
    scopedSlots: _vm._u([{
      key: "drafterTemp",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis"
        }, [_vm._v(_vm._s(row.organName) + " / " + _vm._s(row.postName))])];
      }
    }, {
      key: "repairsStatus",
      fn: function fn(repairsStatus, row) {
        return [0 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待受理")]) : _vm._e(), 2 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待派单")]) : _vm._e(), 3 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待接单")]) : _vm._e(), 4 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("不受理")]) : _vm._e(), 5 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("维修中")]) : _vm._e(), 6 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("已完成")]) : _vm._e(), 7 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("待评价")]) : _vm._e(), 8 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("外部维修")]) : _vm._e(), 9 === row.repairsStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("补　录")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', {
          key: "1"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewRigister(row);
            }
          }
        }, [_vm._v("查看")])], 1), row.repairsStatus == 0 ? _c('a-menu-item', {
          key: "2"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.changeClear(row);
            }
          }
        }, [_vm._v("删除")])], 1) : _vm._e(), row.repairsStatus == 0 ? _c('a-menu-item', {
          key: "3"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.listSubmit(row);
            }
          }
        }, [_vm._v("提交")])], 1) : _vm._e(), row.repairsStatus == 7 ? _c('a-menu-item', {
          key: "4"
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.evaluationClick(row);
            }
          }
        }, [_vm._v("评价")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };